import { all } from 'redux-saga/effects'

import { applicationsSaga } from './applications/sagas'
import { recommendationsSaga } from './recommendations/sagas'

export function* candidatesSaga() {
  yield all([applicationsSaga(), recommendationsSaga()])
}
